import { profilePinAuthority } from "../../utils/profileAccess";
import { profileInterfaceLanguage } from "../../utils/profileLanguage";
import { setUser, setProfile as setAnalyticsProfile, clearUser } from "../../analytics";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  getProfilesApi,
  loginWithProfile,
  checkProfilePassword,
  callLogout,
  checkProfilePin,
  getUserLanguage,
  setUserLanguage
} from "../../api/user/user";
import ProfileItem from "../profileItem/ProfileItem";
import localizationStrings from "../../statics/localization";
import { SessionContext } from "../../context/SessionContext";
import { useHistory, useParams } from "react-router-dom";
import { setCookieApi } from "../../api/config/configApi";
import { sendAliveReport } from "../../utils/reporting/customReporting";
import {
  defaultProfileAvatar,
  getColectAgent,
  getWs,
  setWhereFrom
} from "../../statics/config";
import mainLogo from "../../assets/logo/atlas-logo.png";
import { reportingEvent } from "../../statics/reportEventId";
import moment from "moment";
import { getMainboards } from "../../api/vod/vod";
import openKillSessionPopup from "../../utils/openKillSessionPopup";
import { postAnalyticsLoginEvent } from "../../api/analytics/analyticsApi";
import ArrowLeftIcon from "../../assets/icons/svg/ArrowLeftIcon";
import ProfilePinForm from "./ProfilePinForm";
import PinRecovery from "./PinRecovery";
import { getProfileCopy } from "../profileSettings/profileCopy";

const ProfileList = ({ isFromProfileLogin }) => {
  const copy = getProfileCopy();
  useEffect(() => {
    document.body.classList.add("atlas-profiles-open");
    return () => {
      document.body.classList.remove("atlas-profiles-open");
      clearTimeout(timeoutRef.current);
      pinAttemptRef.current = -1;
    };
  }, []);
  const [showPinCode, setShowPinCode] = useState(false);
  const [showEditPinCode, setShowEditPinCode] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [pinCode, setPinCode] = useState("");
  const [pinError, setPinError] = useState("");
  const pinAttemptRef = useRef(0);
  const submittingRef = useRef(false);
  const [avatar, setAvatar] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [showProfileDetail, setShowProfileDetail] = useState(false);
  const [closeClicked, setCloseClicked] = useState(0);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(false);
  const [showCloseIcon, setShowCloseIcon] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const {
    hasLoggedIn,
    profile,
    setProfile,
    adminProfile,
    userFrameConfig,
    userInfo,
    setSelectedChannel,
    setAllProfiles,
    allProfiles,
    handleLogout
  } = useContext(SessionContext);
  let history = useHistory();
  const timeoutRef = useRef(null);
  const addButton = {
    id: -1,
    name: localizationStrings.profile.add
  };
  let { id } = useParams(); //profilecode if click on navbar
  const isAvatarOpened = useRef(false);
  let item = JSON.parse(localStorage.getItem("profile"));
  if (item?.pin) item.pin = window.atob(item.pin);
  let currentProfile = item;

  useEffect(() => {
    // console.log("deneme",id,allProfiles);

    if (id && id !== "all") {
      let selectedProfile = allProfiles.find((item) => item.id == id);

      if (selectedProfile) {
        onProfileSelection(selectedProfile);
      }
    }
  }, []);

  useEffect(() => {
    if (hasLoggedIn === null) return;
    !hasLoggedIn && history.replace("/login");
  }, []);

  const getBackgroundImage = async () => {
    const { data } = await getMainboards(6);
    if (data.returncode === "0") {
      let obj = data.data[0];
      let poster = obj?.posterpath + obj?.phonebanner;
      setBackgroundImageUrl(poster);
      localStorage.setItem("backgroundImageUrl", poster);
    }
  };

  const getProfiles = async () => {
    const { data } = await getProfilesApi();

    if (!!data) {
      setAllProfiles(data);
      localStorage.setItem("profiles", JSON.stringify(data));
    }
  };

  const cancelPin = () => {
    pinAttemptRef.current++;
    submittingRef.current = false;
    clearTimeout(timeoutRef.current);
    setPinCode("");
    setPinError("");
    setShowPinCode(false);
    setShowEditPinCode(false);
    setShowLoading(false);
    setShowCloseIcon(false);
  };

  const onProfileSelection = (item) => {
    cancelPin();
    setSelectedProfile(item);
    item.posterimage = item?.avatar || defaultProfileAvatar;
    setAvatar(item.posterimage);
    const needsPin = !!profilePinAuthority(item, currentProfile, allProfiles);
    if (!needsPin) {
      setShowLoading(true);
      setShowCloseIcon(true);
      setShowPinCode(true);
      loginProfile(item);
    } else {
      setShowPinCode(true);
    }
  };

  const goSettings = (item) => {
    cancelPin();
    setSelectedProfile(item);
    item.posterimage = item?.avatar || defaultProfileAvatar;
    setAvatar(item.posterimage);
    if (!profilePinAuthority(item, currentProfile, allProfiles, true)) {
      history.push(`/profile/${item.id}`);
    } else {
      setShowEditPinCode(true);
    }
  };

  const loginProfile = async (item) => {
    const attempt = pinAttemptRef.current;
    setShowLoading(true);
    try {
      //setShowLoading(true);
      //setShowPinCode(true);

      // A guardian PIN authorizes this action; it is never the target profile's PIN.
      item = { ...item, pin: item?.hasPin && profilePinAuthority(item, currentProfile, allProfiles) === item.id ? pinCode : "" };

      setShowCloseIcon(false);
      const response = await loginWithProfile(item.id, pinCode);
      if (attempt !== pinAttemptRef.current) return;
      if (response.status !== 200) throw new Error("Profile selection failed");

      if (response.status === 200) {
        sendLoginAnalytics(item.id);
        const userToken = localStorage.getItem("userToken");
        if (userToken) setUser({ type: "mw_token", token: userToken });
        setAnalyticsProfile(item.id, item.kid);
        setSelectedChannel(null);
        item.pin = item.pin ? window.btoa(item.pin) : "";
        localStorage.setItem("profile", JSON.stringify(item));
        localStorage.setItem("profiles", JSON.stringify(allProfiles));
        if (item?.pin) item.pin = window.atob(item.pin);
        setProfile(item);

        /// set language ///
        let langKey = "eng";
        try {
          const langData = await getUserLang();
          langKey = profileInterfaceLanguage(langData?.language);
        } catch (_) {
          langKey = profileInterfaceLanguage(localStorage.getItem("language"));
        }
        localStorage.setItem("language", langKey);

        localizationStrings.setLanguage(langKey);

        /// set language ///

        history.push("/dashboard/home");
      }
    } catch (error) {
      if (attempt === pinAttemptRef.current) {
        setShowLoading(false);
        setShowCloseIcon(false);
        setPinError(copy.pinError);
        submittingRef.current = false;
      }
    }
  };

  const getUserLang = async () => {
    const { data } = await getUserLanguage();

    return data;
  };

  const sendLoginAnalytics = async (id) => {
    await postAnalyticsLoginEvent(id);
  };

  const checkPinCode = async () => {
    if (submittingRef.current) return;
    if (!profilePinAuthority(selectedProfile, currentProfile, allProfiles, showEditPinCode)) {
      submittingRef.current = true;
      return loginProfile(selectedProfile);
    }
    if (!/^\d{4}$/.test(pinCode)) {
      setPinError(localizationStrings.profile.pinLength);
      return;
    }
    const attempt = ++pinAttemptRef.current;
    submittingRef.current = true;
    setPinError("");
    setShowLoading(true);
    setShowCloseIcon(true);
    try {
      const authorityId = profilePinAuthority(selectedProfile, currentProfile, allProfiles, showEditPinCode);
      if (!allProfiles.some(entry => entry.id === authorityId)) throw new Error("PIN authority is unavailable");
      const { data } = await checkProfilePin(authorityId, pinCode);
      if (attempt !== pinAttemptRef.current) return;
      if (!data) {
        setPinError(localizationStrings.wrongPinText);
        setShowLoading(false);
        setShowCloseIcon(false);
        submittingRef.current = false;
        return;
      }
      if (showEditPinCode) {
        sessionStorage.setItem("pin", pinCode);
        history.push(`/profile/${selectedProfile.id}`);
      } else if (!isFromProfileLogin) {
        loginProfile(selectedProfile);
        if (document.pictureInPictureElement) {
          setWhereFrom("");
          document.exitPictureInPicture().catch(() => {});
        }
      } else {
        loginProfile(selectedProfile);
      }
    } catch (error) {
      if (attempt !== pinAttemptRef.current) return;
      setPinError(copy.pinError);
      setShowLoading(false);
      setShowCloseIcon(false);
      submittingRef.current = false;
    }
  };

  const logout = async () => {
    const { data } = await callLogout(userInfo?.usercode);
    if (data.ReturnCode === "0") {
      let collectAgent = getColectAgent();
      if (collectAgent) {
        let eventtime = moment(
          moment().valueOf() - parseInt(localStorage.getItem("timeDiff"))
        )
          .utc()
          .format("yyyyMMDDHHmmss");

        collectAgent.logLogout({
          eventid: reportingEvent.E_LOGIN_OUT,
          eventtime: eventtime, //login triggering time (String UTC time, eg: "20210326101813"
          actiontime: eventtime,
          result: "0",
          logintype: 0 //login type 0: Account login, 1: Mobile login, 2: Mailbox login, 3: Loginname login (String, eg: "3."
        });
      }
      sendAliveReport();
      let ws = getWs();
      if (ws?.readyState === WebSocket.OPEN) {
        let prams = {
          TransactionID: JSON.stringify(new Date().getTime()),
          DeviceID: localStorage.getItem("deviceid"),
          UserID: userInfo?.usercode,
          TerminalFlag: 4,
          UserToken: userInfo?.usertoken,
          DKey: 0,
          Timestamp: JSON.stringify(new Date().getTime()),
          MsgType: "terminaldelreq"
        };
        ws.send(JSON.stringify(prams));
      }

      clearUser();
      if (parseInt(localStorage.getItem("logintype")) == 4) {
        const language = localStorage.getItem("language");
        localStorage.clear();
        if (language) {
          localStorage.setItem("language", language);
        }
        openKillSessionPopup(userFrameConfig?.easHttpsDomain);
        //window.location.replace(fastLoginSessionKillUrl);
      } else {
        const language = localStorage.getItem("language");
        localStorage.clear();
        if (language) {
          localStorage.setItem("language", language);
        }
        window.location.replace(userFrameConfig?.easHttpsDomain);
      }
    }
  };

  const removeCookieApi = async (key, value) => {
    const { data } = await setCookieApi(key, value);
    if (data.returncode === "0") {
      if (key === "upd") {
        removeCookieApi("uid", "");
      } else if (key === "uid") {
        logout();
      }
    }
  };

  const renderedItems = allProfiles.map((item) => {
    return (
      <ProfileItem
        key={item.id}
        item={item}
        onSelection={onProfileSelection}
        currentProfile={currentProfile}
        isFromProfileLogin={isFromProfileLogin}
        count={allProfiles.length + 1}
        onEditClick={goSettings}
        isEditing={isEditing}
      />
    );
  });

  useEffect(() => {
    // getBackgroundImage();
    getProfiles();
  }, []);

  return (
    <section
      className="profile-container atlas-profiles"
      style={{ background: `url(${backgroundImageUrl}) center center` }}
    >
      <div className="row">
        <div className="logo-wrapper">
          <img src={mainLogo} alt="atlas logo" className="atlas-logo" />
        </div>
        {/* Back butonunda faydalanilabilir. */}
        {(!isFromProfileLogin && !showLoading) ||
        (isFromProfileLogin &&
          (showPinCode || showEditPinCode) &&
          !showLoading) ? (
          <button
            type="button"
            className="close"
            onClick={() => {
              if (isFromProfileLogin || showPinCode || showEditPinCode) {
                cancelPin();
              } else if (showProfileDetail) {
                if (isAvatarOpened.current) {
                  let count = closeClicked;
                  setCloseClicked(++count);
                } else {
                  setShowProfileDetail(false);
                }
              } else {
                history.push("/dashboard");
              }
            }}
          >
            <ArrowLeftIcon />
            <span>{localizationStrings.back}</span>
          </button>
        ) : null}
      </div>
      {showPinCode || showEditPinCode ? (
        <>
        <ProfilePinForm
          profile={{ ...selectedProfile, hasPin: !!profilePinAuthority(selectedProfile, currentProfile, allProfiles, showEditPinCode) }}
          note={profilePinAuthority(selectedProfile, currentProfile, allProfiles, showEditPinCode) !== selectedProfile?.id ? copy.parentPinNote : undefined}
          avatar={avatar}
          value={pinCode}
          onChange={(value) => {
            setPinCode(value);
            setPinError("");
          }}
          onSubmit={checkPinCode}
          onCancel={cancelPin}
          loading={showLoading}
          canCancel={showCloseIcon}
          editing={showEditPinCode}
          error={pinError}
        />
        <PinRecovery key={`${selectedProfile?.id}-${showEditPinCode}`} profileId={profilePinAuthority(selectedProfile, currentProfile, allProfiles, showEditPinCode)} disabled={showLoading} onReset={() => { setPinCode(""); setPinError(""); }} />
        </>
      ) : (
        <>
          <div className="profile-wrapper">
            <header className="profiles-heading">
              <span className="profiles-eyebrow">{copy.eyebrow}</span>
              <h1>{isEditing ? copy.manage : copy.choose}</h1>
              <p>{isEditing ? copy.manageNote : copy.intro}</p>
            </header>
            <div className="profile-items-box">
              {renderedItems}
              {!isFromProfileLogin && allProfiles.length < 5 ? (
                <ProfileItem
                  item={addButton}
                  onSelection={() => {
                    history.push("/profile/new");
                  }}
                  count={allProfiles?.length + 1}
                  isFromProfileLogin={isFromProfileLogin}
                />
              ) : null}
            </div>

            {/* {isFromProfileLogin ? (
            <div
            className="red-button"
            onClick={() => {
              handleLogout();
              history.replace("/login");
              }}
              >
              {localizationStrings.logout2}
              </div>
              ) : null} */}
          </div>
          {!isFromProfileLogin ? (
            <button
              type="button"
              aria-pressed={isEditing}
              className={`edit-profiles-button${isEditing ? " editing" : ""}`}
              onClick={() => {
                setIsEditing(!isEditing);
              }}
            >
              {isEditing
                ? localizationStrings.done
                : localizationStrings.editProfile}
            </button>
          ) : null}
        </>
      )}
      {/* <div className="profile-gradient"></div>
      <div className="profile-gradient-2"></div> */}
    </section>
  );
};

export default ProfileList;
